import { render } from "./UploadCsv.vue?vue&type=template&id=0fba9643"
import script from "./UploadCsv.vue?vue&type=script&lang=js"
export * from "./UploadCsv.vue?vue&type=script&lang=js"

import "./UploadCsv.vue?vue&type=style&index=0&id=0fba9643&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__